import translations from './translations.json';


export * from './components/DFARegistrationForm';

export const registration = {
    translations,
};
